import axios from "axios";

const BASE_URL_V1 = "https://api-uat.nispand.com/v1";
const BASE_URL_V2 = "https://api-uat.nispand.com/v2";

export const createSectionApi = (data) => {
  return axios.post(`${BASE_URL_V2}/section`, data);
};

export const updateSectionApi = (id, data) => {
  return axios.put(`${BASE_URL_V2}/section/${id}`, data);
};

export const getSectionByIdApi = (id) => {
  return axios.get(`${BASE_URL_V2}/section/${id}`);
};

export const getAllSectionsApi = (page = 1, limit = 10) => {
  return axios.get(`${BASE_URL_V2}/section?page=${page}&limit=${limit}`);
};

export const getSectionBinApi = (page = 1, limit = 10) => {
  return axios.get(`${BASE_URL_V2}/section/bin/list?page=${page}&limit=${limit}`);
};

export const deleteSectionApi = (id) => {
  return axios.delete(`${BASE_URL_V2}/section/${id}`);
};

export const restoreSectionApi = (id) => {
  return axios.put(`${BASE_URL_V2}/section/restore/${id}`);
};
